import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Team = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await axios.get('https://kidsworkrehab.onrender.com/api/team-members');
        setTeamMembers(response.data);
      } catch (err) {
        console.error('Error fetching team members:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchTeamMembers();
  }, []);

  return (
    <div className="bg-white py-[60px] px-5 min-h-screen font-sans">
      <div className="text-center mb-[50px]">
        <h1 className="text-[#1976d2] text-[3em] md:text-[2.2em] mb-[15px] font-bold bg-gradient-to-br from-[#1976d2] to-[#1e88e5] bg-clip-text text-transparent">Our Multidisciplinary Team</h1>
        <p className="text-[#424242] text-[1.2em] font-light max-w-[600px] mx-auto">
          Meet our experienced professionals dedicated to your child's growth and development
        </p>
      </div>

      {loading ? (
        <div className="text-center py-[60px] px-5 text-[#1976d2] text-[1.2em]">Loading team members...</div>
      ) : teamMembers.length === 0 ? (
        <div className="text-center py-[60px] px-5 text-[#999] text-[1.2em]">
          No team members available at the moment. Please check back later.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-[25px] md:gap-[35px] max-w-[1200px] mx-auto px-5 md:px-[20px]">
          {teamMembers.map((member) => (
            <div key={member._id} className="bg-white rounded-[20px] p-[30px] md:p-[25px] shadow-[0_6px_25px_rgba(25,118,210,0.12)] transition-all duration-300 border-2 border-[#1e88e5]/10 text-center relative overflow-hidden group hover:-translate-y-[10px] hover:shadow-[0_12px_40px_rgba(25,118,210,0.25)] before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-[5px] before:bg-gradient-to-r before:from-[#1e88e5] before:to-[#1976d2] before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
              {member.imageUrl && (
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className="w-[200px] h-[200px] md:w-[150px] md:h-[150px] rounded-full object-cover mx-auto mb-[25px] border-[5px] border-[#bbdefb] shadow-[0_4px_15px_rgba(0,0,0,0.15)] transition-all duration-300 group-hover:scale-105 group-hover:border-[#1e88e5] group-hover:shadow-[0_6px_20px_rgba(25,118,210,0.3)]"
                />
              )}
              <h2 className="text-[#1976d2] text-[1.6em] mb-[10px] font-semibold">{member.name}</h2>
              <h3 className="text-[#1e88e5] text-[1.1em] mb-[15px] font-medium italic">{member.role}</h3>
              <p className="text-[#424242] text-[1em] leading-[1.7] m-0">{member.description}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Team;

